/**
 * Mozambican metical.
 */
export var MZN = {
  code: 'MZN',
  base: 10,
  exponent: 2
};